<template>
    <footer>
        <div class="container">
            <div class="footer">
                <div class="footer-column">
                    <!-- <router-link to="/">
                            <h1>{{ footer_settings.footer_heading?.value }}</h1>
                        </router-link>
                        <p>{{ footer_settings.footer_brief?.value }}</p> -->
                    <h4 class="column_title">عن المبادرة</h4>
                    <div class="column_links">
                        <a href="#">من نحن</a>
                        <a href="#">الحملات</a>
                        <a href="#">ضحايا التعذيب</a>
                        <a href="#">اتصل بنا</a>
                    </div>
                </div>
                <div class="footer-column">
                    <h4 class="column_title">المستجدات</h4>
                    <div class="column_links">
                        <a href="#">الأخبار</a>
                        <a href="#">البيانات الصحفية</a>
                        <a href="#">التقارير</a>
                        <a href="#">الخريطة</a>
                    </div>
                </div>
                <!-- <div class="footer-column">
                        <ul>
                            <li v-if="footer_settings.contact_mail">
                                <h5>{{ $t("mail") }}</h5>
                                <a :href="'mailto:' + footer_settings.contact_mail?.value"><b>{{
                                    footer_settings.contact_mail?.value }}</b></a>
                            </li>
                            <li v-if="footer_settings.contact_phone">
                                <h5>{{ $t("call") }}</h5>
                                <a class="tel" target="_blank"
                                    :href="'https://api.whatsapp.com/send/?phone=' + footer_settings.contact_phone?.value.replace(/\s/g, '')">
                                    <b>{{ footer_settings.contact_phone?.value }}</b>
                                    <font-awesome-icon :icon="'fa-brands fa-whatsapp'" />
                                </a>
                            </li>
                        </ul>
                    </div> -->
                <div class="footer-column">
                    <h4 class="column_title">{{ $t("follow") }}</h4>
                    <div class="column_links">
                        <a v-for="social_link in social_links" :href="social_link.network_url" target="_blank">
                            <font-awesome-icon :icon="'fa-brands ' + social_link.network_icon" />
                            <b>{{ social_link.network_title }}</b>
                        </a>
                    </div>
                </div>
                <div class="footer-column">
                    <form action="" class="newsletter_form">
                        <input type="email" class="form-control" :placeholder="$t('email')">
                        <button class="btn btn-main">{{ $t("subscribe") }}</button>
                    </form>
                </div>
            </div>
            <div class="rights">
                <div>
                    <a href="#" class="footer_logo">
                        <img src="https://torturemap.org/wp-content/uploads/2025/03/Artboard-96@10x2.png" alt="">
                    </a>
                </div>
                <p>جميع الحقوق محفوظة 2026 © تصميم بواسطة مبادرة أوقفوا التعذيب</p>
                <!-- <p>{{ footer_settings.copyright_text?.value }}</p> -->
            </div>
        </div>
    </footer>
</template>

<script>
import axios from 'axios'
import Button from "./Button.vue";
import { createToaster } from "@meforma/vue-toaster";
const toaster = createToaster({});
const base_url = process.env.VUE_APP_BASE_URL;

export default {
    name: 'Footer',
    components: {
        Button,
    },
    data: function () {
        return {
            footer_settings: [],
            social_links: [],
        };
    },
    beforeMount() {
        this.get_footer_settings();
        this.get_social_links();
    },
    methods: {
        get_footer_settings() {
            var params = {
                keys: [
                    'footer_heading',
                    'footer_brief',
                    'contact_mail',
                    'contact_phone',
                    'copyright_text'
                ],
                locale: process.env.VUE_APP_DEFAULT_LOCALE,
            };
            axios
                .get(base_url + "/get_settings", { params: params })

                .then((response) => {
                    this.footer_settings = response.data.data;
                    console.log(this.footer_settings.copyright_text?.value);

                })
                .catch((error) => {
                    let res = error.response.data;
                });
        },
        get_social_links() {
            var params = {
                slug: 'social_media',
                locale: process.env.VUE_APP_DEFAULT_LOCALE,
            };
            axios
                .get(base_url + "/getSectionBySlug", { params: params })

                .then((response) => {
                    this.social_links = response.data.data.network.extra;
                })
                .catch((error) => {
                    let res = error.response.data;
                });
        },
    },

}
</script>

<style scoped>
footer {
    background-color: black;
    transition: 0.3s ease-in-out;
    border-top: 5px solid #e82a00;
}

.container {
    max-width: 1140px;
}

.footer {
    position: relative;
    display: grid;
    padding: 50px 0;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px 0;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.footer-column .column_title {
    font-size: 18px;
    font-weight: 500;
    color: #ffffff !important;
    margin: 0;
    line-height: 1;
}

.footer-column .column_links {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.footer-column .column_links a {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 14px;
    font-weight: 300;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.79) !important;
}

.footer .svg-inline--fa {
    width: 20px;
}

.footer .newsletter_form {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.footer .newsletter_form>* {
    border-radius: 0 !important;
    padding: 15px 30px !important;
}

.footer .newsletter_form input::placeholder {
    font-size: 15px;
    color: #b7b7b7;
}

.footer .newsletter_form input {
    font-size: 15px !important;
    color: #7a7a7a;
    padding: 12px 16px !important;
    border-radius: 0;
    margin: 0;
    background-color: #fff !important;
}

.footer .newsletter_form button {
    line-height: 1.1 !important;
    font-weight: 500;
}

.rights {
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 30px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.25);
}

.rights>* {
    flex: 1;
}

.rights .footer_logo {
    display: block;
    width: 120px;
}

.rights p {
    text-align: end;
    color: white;
    margin: 0;
    font-size: 13px;
    font-weight: 500;
}

@media (max-width: 768px) {
    .footer {
        grid-template-columns: repeat(2, 1fr);
    }

    .rights {
        flex-direction: column;
    }

    .rights p {

        text-align: center;
    }
}

@media (max-width: 480px) {
    .footer {
        grid-template-columns: 1fr;
        padding: 20px;
    }
}
</style>